import { useEffect, useState } from "react";
import LuvmeIcon from "@/components/LuvmeIcon";

export default function IntroSplash() {
  const [show, setShow] = useState(() => !sessionStorage.getItem("luvme_intro_seen"));
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (!show) return;
    sessionStorage.setItem("luvme_intro_seen", "1");
    const t1 = setTimeout(() => setLeaving(true), 1700);
    const t2 = setTimeout(() => setShow(false), 2300);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [show]);

  if (!show) return null;

  const skip = () => { setLeaving(true); setTimeout(() => setShow(false), 350); };

  return (
    <div
      onClick={skip}
      data-testid="intro-splash"
      className={`fixed inset-0 z-[100] flex items-center justify-center bg-[#0D0D0D] transition-opacity duration-500 ${leaving ? "opacity-0 pointer-events-none" : "opacity-100"}`}
    >
      <div className="flex flex-col items-center gap-4">
        <div className="luvme-intro-pulse">
          <LuvmeIcon className="w-20 h-20 sm:w-24 sm:h-24" animated />
        </div>
        <span className="text-4xl sm:text-5xl font-black font-heading tracking-tight luvme-intro-word">Luvme</span>
      </div>
    </div>
  );
}
